<template lang="pug">
div.tabs-container
  ul.nav.nav-tabs
    li.nav-item.visibility__tab(v-for="tab in tabs" @click="selectTab(tab)" data-cy="tab_item")
      a.nav-link.px-0(href="#" data-toggle="tab" :class="{ 'active': tabSelected(tab) }")
        | {{ tab.label }}
  div.tabs-container-content(
    v-for="tab in tabs"
    v-show="tabSelected(tab)"
    :class="{ collapsed: collapsed, expanded: !collapsed }"
    data-cy="tabs_content"
  )
    slot(:name="tab.key")
  li.nav-item.botton_more_and_less.d-flex.justify-content-center(
    data-cy="tab_collapse"
    @click="toggleCollapsed"
  )
    a.nav-link.style__button(href="#")
      span(data-cy="see_more" v-if="collapsed")
        i.fa.fa-plus-circle.mr-2
        | {{ t('components.layout.tabs_container.see_more') }}
      span(data-cy="see_less" v-else)
        i.fa.fa-minus-circle.mr-2
        | {{ t('components.layout.tabs_container.see_less') }}
</template>

<script>
import mixins from 'common/mixins.js'

export default {
  name: 'tabs-container-vue',
  props: {
    tabs: { type: Array }
  },
  mixins: [mixins.translate],
  data() {
    return {
      selected: this.tabs[0].key,
      collapsed: true
    }
  },
  methods: {
    selectTab(tab) {
      this.selected = tab.key
    },
    changeTab(key){
      this.selected = key
    },
    tabSelected(tab) {
      return this.selected == tab.key
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    }
  }
}
</script>
